// extracted by mini-css-extract-plugin
export var productImage = "_xo-0";